<!--
    Program: ContentHistory.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{pageTitle}}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->
            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w100">
                            <li class="tit_150">
                                Country
                                <em class="txt_mandatory">*</em>
                            </li>
                            <li class="srch_a" data-input-type="input">
                                <select
                                    name="countries"
                                    id="selectCountry"
                                    ref="selectCountry"
                                    class="slt_white w230p mr5"
                                    v-model="selectedCountry"
                                    @change="onSelectCountry($event)"
                                >
                                    <option value="-">Select</option>
                                    <option
                                        v-for="item in availableCountryList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                                <span class="clearable w100-240">
                                    <input
                                        type="text"
                                        id="txtSelectedCountryList"
                                        class="text_input"
                                        maxlength="300"
                                        :value="selectedCountryListStr"
                                        @keydown.prevent
                                        placeholder
                                        v-clearable:onClick="resetSelectedCountryList"
                                    />
                                </span>
                            </li>
                        </ul>
                        <ul class="w100">
                            <li class="tit_150">Title</li>
                            <li class="srch_a" data-input-type="input">
                                <span class="clearable">
                                    <input
                                        type="text"
                                        class="text_input w100"
                                        maxlength="100"
                                        v-model="title"
                                        v-clearable
                                        placeholder
                                        value
                                    />
                                </span>
                            </li>
                        </ul>
                        <ul class="w100">
                            <li class="tit_150">Date</li>
                            <li data-input-type="date">
                                <fieldset class="ui_fieldset">
                                    <label class="date-wrap">
                                        <input
                                            id="fromDate"
                                            type="text"
                                            class="date_input w100"
                                            placeholder="From Date"
                                            maxlength="20"
                                            readonly
                                        />
                                        <a href="javascript:" class="in_btn" id="icoFromDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="from-picker-container" />
                                    <em class="txt_space"></em>
                                    <label class="date-wrap">
                                        <input
                                            id="toDate"
                                            type="text"
                                            class="date_input w100"
                                            placeholder="Until Date"
                                            maxlength="20"
                                            readonly
                                        />
                                        <a href="javascript:" class="in_btn" id="icoToDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">Open Calendar</span>
                                        </a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;" />
                                </fieldset>
                            </li>
                        </ul>

                        <ul class="w49">
                            <li class="tit_150">Content Type</li>
                            <li data-input-type="select" class="w100-150">
                                <select
                                    name="contentTypeList"
                                    id="selectContentTypeList"
                                    class="slt_white w100"
                                    v-model="selectedContentType"
                                >
                                    <option value="ALL">ALL</option>
                                    <option
                                        v-for="item in availableContentTypeList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Category</li>
                            <li data-input-type="select" class="w100-150">
                                <select
                                    name="categoryList"
                                    id="selectCategoryList"
                                    class="slt_white w100"
                                    v-model="selectedCategory"
                                >
                                    <option value="ALL">ALL</option>
                                    <option
                                        v-for="item in availableCategoryList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Model</li>
                            <li data-input-type="select" class="w100-150">
                                <select
                                    name="modelList"
                                    id="selectModelList"
                                    class="slt_white w100"
                                    v-model="selectedModel"
                                >
                                    <option value="ALL">ALL</option>
                                    <option
                                        v-for="item in availableModelList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </li>
                        </ul>
                        <ul class="w49">
                            <li class="tit_150">Buyer</li>
                            <li data-input-type="select" class="w100-150">
                                <select
                                    name="buyerList"
                                    id="selectBuyerList"
                                    class="slt_white w100"
                                    v-model="selectedBuyer"
                                >
                                    <option value="ALL">ALL</option>
                                    <option
                                        v-for="item in availableBuyerList"
                                        :key="item.CODE_ID"
                                        :value="item.CODE_ID"
                                    >{{item.CODE_NAME}}</option>
                                </select>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <span class="btn">
                            <span class="btn">
                                <a
                                    href="javascript:"
                                    class="btn_srch"
                                    @click="onSearchBtnClick"
                                >Search</a>
                            </span>
                        </span>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Grid Count-->
                <div class="grid_total">
                    Total Count
                    <em>{{ resultCount | numberFormat }}</em>
                </div>
                <!-- Grid "btn-->
                <div class="btn_wrap">
                    <a
                        href="javascript:"
                        class="btn_white"
                        @click="downloadExcelFile()"
                        title
                    >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <div id="grid">
                    <toast-grid
                        gridId="gridContentHistory"
                        :key="gridKey"
                        :data="gridData"
                        :columns="gridColumns"
                        :options="gridOptions"
                        :pageOptions="gridPageOptions"
                        :theme="gridTheme"
                        :isTotalCount="false"
                        v-bind:click="onSelectGridCell"
                    />
                </div>

                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="onGoToPage"
                        align="center"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue            from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import $ from 'jquery';

import qs from 'query-string';
import moment from 'moment';

import { SDLUtil, DateUtil } from '@/utils';

import DatePicker from '~c/DatePicker';

// import HhpCerts from '~c/HhpCerts';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';

import DownloadCountDetailPopup from './DownloadCountDetailPopup';
import ViewCountDetailPopup from './ViewCountDetailPopup';

require('moment-jdateformatparser');

// Toast Grid Custom Renderer
class CustomLinkButtonRenderer {
    constructor(props) {
        const el = document.createElement('a');
        // el.classList.add('btn_sm_white');
        // const { text } = props.columnInfo.renderer.options;
        el.innerText = props.value;
        // eslint-disable-next-line no-script-url
        el.href = 'javascript:';
        el.style.textDecoration = 'underline';
        this.el = el;
    }

    getElement() {
        return this.el;
    }
}

export default {
    name: 'hhp-content-history',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    props: [],
    computed: {
        selectedCountryListStr() {
            const fullNameList = [];
            this.selectedCountryList.forEach(countryId => {
                const matched = this.availableCountryList.find(item => item.CODE_ID === countryId);
                fullNameList.push(matched.CODE_NAME);
            });

            return fullNameList.join(', ');
        },
    },
    data() {
        return {
            ...mapGetters({
                locale: 'getLocale',
            }),

            pageTitle: '',

            // Search Form (Interface)
            availableCountryList: [],
            availableContentTypeList: [],
            availableCategoryList: [],
            availableModelList: [],
            availableBuyerList: [],

            selectedCountry: '-', // current selected item

            selectedCountryList: [], // Able to select multiple

            title: '',

            selectedContentType: 'ALL',
            selectedCategory: 'ALL',
            selectedModel: 'ALL',
            selectedBuyer: 'ALL',

            rangePicker: null,

            startDatePicker: null,
            endDatePicker: null,

            // Data sent to Server
            searchParams: {
                country: '',
                selectedCountryNm: '',
                selectedCountry: '',

                title: '',
                content: 'ALL',
                category: 'ALL',
                model: 'ALL',
                buyer: 'ALL',
                searchToAddDt: '',
                searchFromAddDt: '',
            },

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'Model',
                    name: 'NMMODEL',
                    width: 90,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Content Type',
                    name: 'TYPE',
                    width: 180,
                    align: 'center',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Subject',
                    name: 'TITLE',
                    align: 'left',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Date',
                    name: 'DTCREATE',
                    width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Views',
                    name: 'VIEWS',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: { type: CustomLinkButtonRenderer },
                },
                {
                    header: 'Downloads',
                    name: 'DOWNLOADS',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: { type: CustomLinkButtonRenderer },
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    created() {
        console.log('Component: Mobile Content History created. ');
        this.initLoad();
    },
    mounted() {
        console.log('Component: Mobile Content History mounted.');
        // this.$nextTick(() => {
        //     this.startDatePicker = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate');
        //     this.endDatePicker = DatePicker.create('to-picker-container', 'toDate', 'icoToDate');
        //     this.endDatePicker.setDate(DateUtil.now());
        // });
        this.rangePicker = DatePicker.createRangeWithOpener(
            'from-picker-container', 'fromDate', 'icoFromDate',
            'to-picker-container', 'toDate', 'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            (new moment()).add(-1, 'years').toDate(),
            (new moment()).toDate(),
        );
    },
    methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            await this.fetchInitData()
                .then(data => {
                    console.log('FetchInitData', data);
                    this.setAvailableCountryList(data.countryList);
                    this.setAvailableCategoryList(data.firstCategoryCombo);
                    this.setAvailableContentTypeList(data.contentList);
                })
                .catch(err => {
                });

            SDLUtil.showLoadingBar(false);
        },

        fetchInitData() {
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/contenthistory/ContentHistory.skp`)
                    .then(res => {
                        console.log('CONTENT HISTORY', res);
                        return res.data;
                    })
            );
        },

        setAvailableCountryList(list = []) {
            this.availableCountryList = list;
        },
        setAvailableCategoryList(list = []) {
            this.availableCategoryList = list;
        },
        setAvailableContentTypeList(list = []) {
            this.availableContentTypeList = list;
        },
        setAvailableModelList(list = []) {
            this.availableModelList = list;
        },
        setAvailableBuyerList(list = []) {
            this.availableBuyerList = list;
        },

        resetSelectedCountryList() {
            this.selectedCountry = '-';
            this.selectedCountryList = [];
            this.selectedContentType = 'ALL';
            this.selectedCategory = 'ALL';
            this.selectedModel = 'ALL';
            this.selectedBuyer = 'ALL';
            // this.resetSearchForm();
        },
        resetSearchForm() {
            this.selectedCountry = '-';
            this.selectedCountryList = [];
            this.selectedContentType = 'ALL';
            this.selectedCategory = 'ALL';
            this.selectedModel = 'ALL';
            this.selectedBuyer = 'ALL';
            this.searchToAddDt = '';
            this.searchFromAddDt = '';
            this.title = '';
        },

        async onSelectCountry(event) {
            const selectedValue = event.target.value;
            const idx = this.selectedCountryList.findIndex(code => code === selectedValue);
            if (idx > -1) return;
            this.selectedCountryList.push(selectedValue);

            await this.fetchModelListByCountry();
            await this.fetchBuyerListByCountry();
        },

        fetchModelListByCountry() {
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/contenthistory/selectModelInCountry.skp`, {
                        params: {
                            selectedCountry: this.selectedCountryList.join(','),
                        },
                    })
                    .then(res => {
                        this.setAvailableModelList(res.data.modelList);
                        return res;
                    })
            );
        },

        fetchBuyerListByCountry() {
            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/contenthistory/selectBuyerInCountry.skp`, {
                        params: {
                            selectedCountry: this.selectedCountryList.join(','),
                        },
                    })
                    .then(res => {
                        this.setAvailableBuyerList(res.data.buyerList);
                        return res;
                    })
            );
        },

        onSearchBtnClick() {
            if (!this.validateSearchParams()) return;
            const params = this.prepSearchParams(1);
            this.search(params);
        },

        prepSearchParams(pageNo = 1, exclude = []) {
            const format = moment().toMomentFormatString('MM.dd.yyyy');

            const searchFromAddDt = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const searchToAddDt = this.rangePicker.getEndDate()
                ? moment(this.rangePicker.getEndDate()).formatWithJDF(format)
                : '';

            const params = {
                page: pageNo,
                country: this.selectedCountryList.join(','),
                selectedCountry: this.selectedCountryList.join(','),
                selectedCountryNm: this.selectedCountryListStr,
                buyer: this.selectedBuyer,
                model: this.selectedModel,
                content: this.selectedContentType,
                category: this.selectedCategory,
                title: this.title,
                searchFromAddDt,
                searchToAddDt,
            };

            if (exclude.length > 0) {
                exclude.forEach(item => {
                    if (item in params) delete params[item];
                });
            }

            console.log('search params', params);
            return params;
        },

        validateSearchParams() {
            if (this.selectedCountryList.length === 0) {
                SDLUtil.alert({
                    msg: 'Please select at least one country to start search.',
                });
                return false;
            }
            return true;
        },

        async search(params) {
            SDLUtil.showLoadingBar(true);
            await this.fetchSearchResult(params).then(res => {
                this.lastSearchParams = params;
                this.resultCount = res.data.count;
                let rows = res.data.rows;
/*
                const { viewsAndDownloads } = res.data;
                let { rows } = res.data;
                // console.log('ROWS', rows);
                // 항목과 본횟수, 다운횟수를 따로 내려주기 때문에 map을 이용해 합성.
                rows = rows.map(item => {
                    const found = viewsAndDownloads.find(v => v.CTTID === item.CTTID);
                    if (!found) {
                        Vue.$log.error('could not found', item.CTTID);
                        item.VIEWS = 0;
                        item.DOWNLOADS = 0;
                        return item;
                    }
                    item.VIEWS = found.HITS;
                    item.DOWNLOADS = found.DOWN;
                    return item;
                });
                */
                // console.log(Object.assign([], rows));
                this.setGridData(rows);
                this.currentPage = params.page;
                return res;
            });
            SDLUtil.showLoadingBar(false);
        },

        fetchSearchResult(params) {
            const formData = qs.stringify(params);
            return axios
                .post(`${SDLUtil.API_URL}/basis/anysvcmobile/contenthistory/ContentHistorySearch.skp`, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(res => {
                    console.log('SEARCH RESULT', res);
                    return res;
                });
        },

        setGridData(rows) {
            this.gridData = rows;
            this.gridKey += 1;
        },

        onGoToPage(pageNo) {
            this.lastSearchParams.page = pageNo;
            return this.search(this.lastSearchParams);
        },

        onSelectGridCell(event, rowData) {
            console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            // Need to get Count
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            // console.log('event row', rowData[event.rowKey]);
            // console.log('event row CTTID', rowData[event.rowKey].CTTID);

            const cttid = rowData[event.rowKey].CTTID;
            const type = event.columnName;

            // console.log('CTTID', cttid);

            if (type === 'DOWNLOADS') {
                this.openDownloadsDetailPopup(cttid);
            } else if (type === 'VIEWS') {
                this.openViewsDetailPopup(cttid);
            }
        },

        openViewsDetailPopup(cttid) {
            // console.log('Views CTTID', cttid);
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                ViewCountDetailPopup,
                {
                    cttid: cttid,
                },
                { width: '900px', height: 'auto' },
            );
        },
        openDownloadsDetailPopup(cttid) {
            // console.log('Downs CTTID', cttid);
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                DownloadCountDetailPopup,
                {
                    cttid: cttid,
                },
                { width: '1100px', height: 'auto' },
            );
        },
        downloadExcelFile() {
            console.log('EXCEL DOWNLOAD');
            if (!this.validateSearchParams()) return;

            SDLUtil.showLoadingBar(true);

            const exclude = ['page', 'country', 'selectedCountryNm'];
            // const params = this.prepSearchParams(this.currentPage, exclude);
            const params = this.lastSearchParams;

            return axios
                .get(
                    `${SDLUtil.API_URL}/basis/anysvcmobile/contenthistory/ContentHistoryExcel.skp?${qs.stringify(
                        params,
                    )}`,
                )
                .then(res => {
                    console.log(res);
                    SDLUtil.showLoadingBar(false);
                    if (res.data.EXCEL_FILES.length > 0) {
                        SDLUtil.show(
                            ExcelDownloadPopup,
                            {
                                title: 'Excel Download - Mobile Content History',
                                excelFiles: res.data.excelFiles,
                            }, // component params
                            {
                                height: 'auto',
                            }, // dialog params
                        );
                    } else {
                        SDLUtil.alert({
                            msg: 'Nothing to download',
                        });
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                });
            // window.open(`${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/findContentExceldownload.skp?${params}`);
        },
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/contentHistory/ContentHistory.vue